import React from 'react'

import clsx from 'clsx'

import classes from './ContentImage.module.scss'

/** @type {import("./types").default} */
const ContentImage = ({ image, children, isNarrow }) => (
  <div className={clsx('ContentImage', classes.root)} data-testid="contentful-content-image">
    {image && (
      <img
        src={image.url}
        alt={image.title || 'ContentImage'}
        className={clsx(classes.image, { [classes.narrowImage]: isNarrow })}
      />
    )}
    {children && <div className={classes.caption}>{children}</div>}
  </div>
)

export default ContentImage
